var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-3"},[_c('RegistrarEnvioProcesos',{attrs:{"saveInState":_vm.saveProcesosInState,"esIess":_vm.esCoberturaIess,"maxEnvios":_vm.maxEnvios,"tokenAtencion":_vm.tokenAtencion,"alertNoRegistros":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }